import { render, staticRenderFns } from "./trainVetVideoDetail.vue?vue&type=template&id=1f9d9f58&scoped=true&"
import script from "./trainVetVideoDetail.vue?vue&type=script&lang=js&"
export * from "./trainVetVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./trainVetVideoDetail.vue?vue&type=style&index=0&id=1f9d9f58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9d9f58",
  null
  
)

export default component.exports